import reducer, * as reducers from './reducers';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';

export default {
  reducers,
  reducer,
  actions,
  actionTypes,
  selectors,
};
